import { Controller } from "@hotwired/stimulus"

// Resolution uses the same server-rendered section as new/create. The server
// repeats the lookup on create; this request is only a preview, never a write.
export default class extends Controller {
  static targets = ["lookup"]

  connect() {
    const invalid = this.element.querySelector('[aria-invalid="true"]')
    if (invalid) invalid.focus()
  }

  resolve(event) {
    if (!this.hasLookupTarget || !event.target.value.trim() || !event.target.validity.valid) return
    // Do not replace the form while the user is activating Cancel or Save.
    // Create independently performs the same lookup before it writes.
    if (event.relatedTarget?.closest('button, a')) return
    this.element.requestSubmit(this.lookupTarget)
  }
}
